import type * as React from "react";
import { cn } from "@/lib/utils";

type PageContainerWidth = "full" | "content" | "narrow";
type PageContainerSpacing = "normal" | "compact";
type PageContainerVariant = "default" | "dashboard" | "dense";

const WIDTH_CLASS_NAMES: Record<PageContainerWidth, string> = {
  full: "max-w-none",
  content: "max-w-[84rem]",
  narrow: "max-w-3xl",
};

const SPACING_CLASS_NAMES: Record<PageContainerSpacing, string> = {
  normal: "px-6 py-8 md:px-8 md:py-12 lg:px-12",
  compact: "px-6 py-6 md:px-8 md:py-8 lg:px-12",
};

const VARIANT_CLASS_NAMES: Record<PageContainerVariant, string> = {
  default: "",
  dashboard: "pt-8 md:pt-12 lg:pt-16",
  dense: "py-6 md:py-8",
};

type PageContainerProps = React.ComponentProps<"div"> & {
  width?: PageContainerWidth;
  spacing?: PageContainerSpacing;
  variant?: PageContainerVariant;
};

export function PageContainer({
  width = "content",
  spacing = "normal",
  variant = "default",
  className,
  ...props
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full",
        WIDTH_CLASS_NAMES[width],
        SPACING_CLASS_NAMES[spacing],
        VARIANT_CLASS_NAMES[variant],
        className
      )}
      {...props}
    />
  );
}
